import React, { Fragment } from 'react';
import { FilterModel } from 'shared/commonGrid/common-grid.types';
import { showError } from 'shared/toaster';
import cloneDeep from 'lodash.clonedeep';
import ModalDialog from 'shared/modal/dialog';
import ExportReportDialogBody, { ExportReportDialogBodyFormRef } from 'routes/AccessFunction/containers/AccessFunctionList/components/DialogBody/ExportReportDialogBody';
import i18n from 'i18n';
import moment from 'moment';
import UserAuditGridColumnDefs, { auditTrailsColumnDefVersion } from './user-audit-grid-column-defs';
import CommonGrid, { ICommonGridProperties } from '../../../shared/commonGrid';
import DateTimeCellRenderer from '../../../shared/commonGrid/date-cell-renderer';
import { ROWSELECTION } from '../../../shared/commonGrid/grid-enums';
import DetailCellRenderer from './detailCellRenderer';
import exportAuditLogsToFile from '../utils/exportAuditLogs';
import './user-audit-grid.scss';

class UserAuditGrid extends React.Component<any, any> {
    USER_AUDIT_GRID_SETTINGS = 'userAuditGridSettings';

    columnDefs = UserAuditGridColumnDefs;
    exportReportDialogRef: ExportReportDialogBodyFormRef | null = null;

    filterCriteria = '';

    constructor(props: any) {
      super(props);

      this.state = {
        exportReportDialog: {
          isOpen: false,
          title: '',
          customComponent: () => null,
          onSubmit: () => null,
          actionText: '',
          onClose: () => null,
        }
      };
    }

    handleSelection = (e: any) => {
      this.setState({ selection: e.api.getSelectedRows() });
    };

    handleGetResultsFromServer = (body:any) => {
      this.filterCriteria = cloneDeep(body);
      return this.props.getAllUserAudit(body);
    }

    handleGetGridSettingsFromServer = () => {
      return this.props.getUserSettings(this.USER_AUDIT_GRID_SETTINGS,
        this.props.authentication.userId);
    }

    saveGridSettings = (auditGridSettings: { [key: string]: any }) => {
      if (auditGridSettings !== null) {
        this.props.putUserSettings(this.USER_AUDIT_GRID_SETTINGS, this.props.authentication.userId,
          auditGridSettings);
      }
    }

    adaptToFilterModel = (filterModel:FilterModel): FilterModel => {
      if (filterModel.status && filterModel.status.values.length > 0) {
        filterModel.status.filterType = 'text';
        filterModel.status.type = 'equals';
        const filterText = filterModel.status.values[0];
        filterModel.status.filter = '200 OK';
        if (filterText !== 'Success') {
          filterModel.status.type = 'notEqual';
        }
        delete filterModel.status.values
      }
      return filterModel;
    }

    onHandleExport = () => {
      const exportReportDialog = {
        isOpen: true,
        title: i18n.t('audit.userAudit.grid.exportPopup.title'),
        customComponent: () => (
          <ExportReportDialogBody
            ref={(ref: any) => {
              this.exportReportDialogRef = ref;
            }}
            exportOption={{
              supportedFileFormats: ['csv'],
              fileFormat: 'csv',
              filename: `userAudit_export_${moment().valueOf()}`,
              isExporting: false
            }}
          >
            {i18n.t('audit.userAudit.grid.exportPopup.message')}
          </ExportReportDialogBody>
        ),
        actionText: i18n.t('audit.userAudit.grid.exportPopup.action'),
        onSubmit: this.onReportSubmit,
        onClose: () => {
          this.setState({
            exportReportDialog: {
              ...this.state.exportReportDialog,
              isOpen: false
            }
          });
        }
      };

      this.setState({ exportReportDialog });
    };

    onReportSubmit = () => {
      if (this.exportReportDialogRef) {
        exportAuditLogsToFile(this.filterCriteria, this.exportReportDialogRef.getExportOption()).then((isSuccessful) => {
          if (!isSuccessful) {
            showError('Failed to export cases to file.');
          }
        });
      }
    };

    render() {
      const { exportReportDialog } = this.state;
      const components = {
        datetimeCellRenderer: DateTimeCellRenderer,
      };
      const commonGridProps: ICommonGridProperties = {
        onSelectionChanged: this.handleSelection,
        rowSelection: ROWSELECTION.SINGLE,
        detailCellRenderer: DetailCellRenderer,
        masterDetail: true,
        columnDefs: this.columnDefs,
        rowData: this.props.userAudit.userAudit,
        context: this,
        pagination: true,
        noResults: false,
        components,
        getGridResultsFromServer: this.handleGetResultsFromServer,
        renderDataFromServer: true,
        getGridSettingsFromServer: this.handleGetGridSettingsFromServer,
        saveGridSettings: this.saveGridSettings,
        adaptToFilterModel: this.adaptToFilterModel,
        isBeforeLogout: this.props.authentication.beforeLogout,
        columnDefsVersion: auditTrailsColumnDefVersion,
        onExport: this.onHandleExport
      };
      return (
        <Fragment>
          <div style={{ height: '96%' }}>
            <CommonGrid
              {...commonGridProps}
            />
          </div>
          <ModalDialog
            width="500px"
            isOpen={exportReportDialog.isOpen}
            title={exportReportDialog.title}
            customComponent={exportReportDialog.customComponent}
            actionText={exportReportDialog.actionText}
            onSubmit={exportReportDialog.onSubmit}
            onClose={exportReportDialog.onClose}
          />
        </Fragment>
      );
    }
}

export default UserAuditGrid;
